import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import CompaniesCarrousel from "../Carrousel/CompaniesCarrousel";
import HomeDesktop01 from "../../img/HomeDesktop01.png";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  box: {
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backgroundImage: `url(${HomeDesktop01})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  titleContainer: {
    mt: { xs: "76px", md: "150px", lg: "180px" },
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  title: {
    color: theme.palette.red.main,
    fontWeight: "600",
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontSize: { xs: "14px", md: "16px" },
  },
  subtitle: {
    fontFamily: theme.typography.montserrat.light,
    color: theme.palette.blue.main,
    fontSize: { xs: "32px", md: "54px", lg: "65px" },
    lineHeight: { xs: "33px", md: "63px", lg: "79px" },
    mt: "17px",
    textAlign: "center",
    maxWidth: { xs: "293px", md: "800px", lg: "900px" },
  },
  text: {
    fontFamily: theme.typography.anaHeim.regular,
    color: theme.palette.blue.main,
    mt: "28px",
    fontSize: { xs: "20px", md: "24px", lg: "26px" },
    lineHeight: { xs: "26px", md: "32px", lg: "36px" },
    mb: "40px",
  },
  span: { fontWeight: "bold" },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
});

const P5Commitment = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const { title, subtitle, graduatesJob } = useTranslation(
    pathname,
    "P5Commitment"
  );

  return (
    <Box sx={classes.box}>
      <Box sx={classes.container}>
        <Box sx={classes.titleContainer}>
          {isMobile ? null : <div style={classes.line}></div>}
          <Typography sx={classes.title}>{title}</Typography>
        </Box>

        <Typography sx={classes.subtitle}>
          <span style={classes.span}>
            {subtitle[0]}
            {isMobile && <br></br>}
            {subtitle[1]}
            {!isMobile && <br></br>}
            {subtitle[2]}
          </span>
        </Typography>

        <Typography sx={classes.text}>{graduatesJob}</Typography>
      </Box>
      <CompaniesCarrousel />
    </Box>
  );
};

export default P5Commitment;
